import { GuiBase } from "../GuiBase";

export class GuiLogOutBrowser extends GuiBase {

    constructor() {
        super("Logout");
    }

}
